import { createContext } from 'react'

export interface FieldGroupContextValue {
  /** Member fields point at this instead of rendering their own. */
  messageId?: string
  invalid: boolean
}

/** Set by `FieldGroup`: one label over several controls has one error, not one per control. */
export const FieldGroupContext = createContext<FieldGroupContextValue | null>(null)
